import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ConfirmEmailComponent } from "./confirm-email/confirm-email.component";
import { AuthGuard } from "../shared/security/auth.guard";

const routes: Routes = [
  {
    path: "account",
    children: [
      { path: "confirm", component: ConfirmEmailComponent },
      { path: "login", component: LoginComponent },
      { path: "logout", component: LogoutComponent },
      { path: "forgot-password", component: ForgotPasswordComponent },
      {
        path: "manage",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
